import { getTruthyValue } from "@draftkings/sportsbook-common-utils";
import { isSettlementStatusVoid, safeString } from "../../../helpers";
import { parseSettlementStatus } from "../../parseSettlementStatus";
import { formatBoostPartiallyAppliedMessage } from "./formatBoostPartiallyAppliedMessage";
import { getSelectionsLength } from "../../parseBet/utils";
const getBoostStatusMap = (dictionary, boostValue) => ({
    Forfeit: {
        messages: [{
                type: "CashOut",
                text: dictionary.myBetsDictionary.BonusCashedOutMessage
            }],
        status: "Inactive"
    },
    Returned: {
        messages: [{
                type: "BonusReturned",
                text: dictionary.myBetsDictionary.BonusReturnedMessage
            }],
        status: "Inactive"
    },
    Original: {
        messages: [],
        status: "Active"
    },
    Downgraded: {
        messages: [],
        status: boostValue === 0 ? "Inactive" : "Active"
    }
});
export function parseProfitBoostBonusMessagesAndStatus(bonus, bet, dictionary) {
    const { status, messages } = getTruthyValue(getBoostStatusMap(dictionary, getTruthyValue(bonus.boostValue, 0))[safeString(bonus.boostStatus)], {});
    const totalSelections = getSelectionsLength(bet.selections);
    const boostedSelections = bet.selections.filter(selection => selection.isInBetBoost);
    const boostedActiveSelections = boostedSelections.filter(selection => !isSettlementStatusVoid(parseSettlementStatus(selection.settlementStatus)));
    const numberOfPicksBoostAppliedOn = getSelectionsLength(boostedActiveSelections);
    if (bonus.boostStatus === "Downgraded") {
        if (bonus.boostOriginalValue !== bonus.boostValue) {
            const message = formatBoostPartiallyAppliedMessage(numberOfPicksBoostAppliedOn, dictionary);
            messages.push({
                type: "BonusDowngraded",
                text: message
            });
            messages.push({
                type: "BonusDowngraded",
                text: dictionary.myBetsDictionary.BonusDowngradedMessage
            });
        }
        else {
            const message = formatBoostPartiallyAppliedMessage(numberOfPicksBoostAppliedOn, dictionary);
            messages.push({
                type: "BonusDowngraded",
                text: message
            });
        }
    }
    else if (status === "Active" && totalSelections > numberOfPicksBoostAppliedOn) {
        const message = formatBoostPartiallyAppliedMessage(getSelectionsLength(boostedSelections), dictionary);
        messages.push({
            type: "Original",
            text: message
        });
    }
    return [status, messages];
}
//# sourceMappingURL=parseProfitBoostBonusMessagesAndStatus.js.map